import Marquee from "react-fast-marquee";
import { TESTIMONIALS } from "../lib/site";

export default function EditorialMarquee() {
  return (
    <section className="py-24 md:py-32 border-y border-[#E5E1D8] bg-bg overflow-hidden" data-testid="testimonial-marquee">
      <div className="mx-auto max-w-[1440px] px-6 md:px-10 mb-10 flex items-end justify-between gap-6">
        <div>
          <div className="overline text-terracotta">Voices from our guests</div>
          <h2 className="font-display text-4xl md:text-5xl mt-3 leading-none">Letters home.</h2>
        </div>
        <div className="hidden md:block text-sm text-ink-soft max-w-xs">
          Words from travellers who stayed, wrote back, and came again.
        </div>
      </div>

      <Marquee speed={28} gradient={false} pauseOnHover>
        {TESTIMONIALS.concat(TESTIMONIALS).map((t, i) => (
          <blockquote key={i} className="mx-14 md:mx-24 max-w-[520px] shrink-0">
            <p className="font-display italic text-3xl md:text-4xl leading-[1.15] text-ink">
              &ldquo;{t.quote}&rdquo;
            </p>
            <footer className="mt-6 flex items-center gap-3 text-ink-soft">
              <span className="w-10 h-px bg-terracotta"/>
              <span className="overline">{t.name} · {t.place}</span>
            </footer>
          </blockquote>
        ))}
      </Marquee>
    </section>
  );
}
